import config from "appConfig";
import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  {
    id: "c1cf8004-1bce-4c02-91a2-0718d5d58330",
    content: "Answer 1",
    options: {
      image: `${config.ASSETS_URL}/04/06/task/task-2-item-1.svg`,
    },
  },
  {
    id: "783afa73-db89-45a1-8296-7361daa3509f",
    content: "Answer 2",
    options: {
      image: `${config.ASSETS_URL}/04/06/task/task-2-item-2.svg`,
    },
  },
  {
    id: "87d6e0f6-407d-4e74-a69b-4c45629e0fc2",
    content: "Answer 3",
    options: {
      image: `${config.ASSETS_URL}/04/06/task/task-2-item-3.svg`,
    },
  },
  {
    id: "d286977e-fdbc-48b1-9263-adacb9f34897",
    content: "Answer 4",
    options: {
      image: `${config.ASSETS_URL}/04/06/task/task-2-item-4.svg`,
    },
  },
];

export const task: Task = {
  id: "15b396ca-f76a-491c-8d84-7bc8e4633909",
  solutionType: "select",
  type: "checkbox",
  options: {
    columns: 2,
    isMultiple: false,
    shuffle: true,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["c1cf8004-1bce-4c02-91a2-0718d5d58330"],
};
